import React, { useState } from "react";
import useStyles from "../../partner/style";
import { TextField } from "@material-ui/core";

const InputProfitProduct = ({ text, setPartnerCode, type, label, name, placeholder, isEnable, isRequired, calculate }) => {
    const classes = useStyles();

    const [isPercentSelected, setIsPercentSelected] = useState(false);

    const onChange = (e) => {
        let start = e.target.selectionStart;
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;
        
        if (val.length > 0) {
            e.target.value = Number(value).toFixed(2);
            e.target.setSelectionRange(start, start);
            setPartnerCode({ ...text, text: Number(value).toFixed(2) });
        }
    }
    const validateField = () => {
        if (text.text != '') {
            setPartnerCode({ ...text, valid: 'true' });
            calculate();
        } else {
            setPartnerCode({ ...text, valid: 'false' });
            calculate();
        }
    }

    const buttonSelected = (index) => (event) => {
        if (index == 1) {
            setIsPercentSelected(false);
            setPartnerCode({ ...text, isProfitByPercent: false });
        } else {
            setIsPercentSelected(true);
            setPartnerCode({ ...text, isProfitByPercent: true });
        }
    };

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>
            <div className={classes.rowButtons}>
                <div style={{ display: "flex" }}>
                    <button
                        className={!isPercentSelected ? classes.selectedButtonProfitLeft : classes.enableButtonProfitLeft}
                        onClick={buttonSelected(1)}
                    >Efectivo</button>

                    <button
                        className={isPercentSelected ? classes.selectedButtonProfitRight : classes.enableButtonProfitRight}
                        onClick={buttonSelected(2)}
                    >Porcentaje</button>
                </div>

                <div style={{ display: "flex", justify: "center", alignItems: "center" }}>
                    {!isPercentSelected ? (
                        <p style={{ fontSize: "18px" }}>$</p>
                    ) : (
                        <></>
                    )}

                    <TextField
                        InputProps={{
                            classes: {
                                focused: classes.textBorder,
                                input: classes.input,
                            },
                        }}
                        disabled={isEnable ?? false}
                        value={text.text}
                        onChange={onChange}
                        placeholder={placeholder}
                        type={type}
                        name={name}
                        onKeyUp={validateField.bind(this)}
                        onBlur={validateField.bind(this)}
                        style={{ width: '85%' }}
                        inputStyle={{ width: '85%' }}
                    />

                    {isPercentSelected ? (
                        <p style={{ fontSize: "18px" }}>%</p>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
}

export default InputProfitProduct;